// handle valid browser - device
export function testValidBrowser(browser) {
  return (
    browser.os !== "iOS" &&
    browser.os !== "Android OS" &&
    (browser.name === "chrome" ||
      browser.name === "firefox" ||
      browser.name === "opera")
  );
}

// handle user media capture
export function captureUserMedia(callback) {
  var params = { audio: true, video: true };
  navigator.mediaDevices
    .getUserMedia(params)
    .then(callback)
    .catch((error) => {
      console.error(JSON.stringify(error));
    });
}

// handle snapshots from firebase
export function snapShotToArray(snapshot) {
  return Object.keys(snapshot.val()).map((id) => ({
    id,
    ...snapshot.val()[id]
  }));
}
